export const bookingLabels = {
  liveEta: 'Live ETA/price will be available on the next step',
  bookDate: 'When would you like to speak to your doctor?',
  area: 'Available in Greater London',
};

export const datePickerFormat = {
  common: 'dd/MM/yyyy',
  withMonth: 'dd MMM yyyy',
  withWeekendDay: 'd MMM, EEEE',
};

export const defaultButtonTypes = {
  unauthorized: 'unauthorizeduser',
  withoutMembership: 'withoutmembership',
};

export const initialFormData = {
  acceptTerms: false,
  postcode: '',
  address: {
    fullAddress: ''
  },
  date: '',
  time: '',
  forename: '',
  surname: '',
  email: '',
  phone: {
    code: '+44',
    number: '',
  },
  symptoms: '',
  comments: '',
  bookingType: '',
  paymentMethod: '',
  billingAddress: '',
  eta: '',
  price: '',
  patient: {
    title: '',
    forename: '',
    surname: '',
    dob: null,
  },
};

export const visitEcommerceItem = {
  value: 195,
  currency: 'GBP',
  item_name: 'visit',
  price: 195,
  quantity: 1
}

export const telemedecineEcommerceItem = {
  value: 60,
  currency: 'GBP',
  item_name: 'telemedecine',
  price: 60,
  quantity: 1
}

export const BOOKING_TIME_TYPES = {
  ASAP: 'ASAP',
  PREBOOK: 'PREBOOK',
  TIME_PERIOD: 'TIME_PERIOD'
};

export const BOOKING_APPOINTMENT_TYPES = {
  PHONE: 'phone',
  VIDEO: 'video',
};

export const bookingCallTypes = [
  { value: BOOKING_APPOINTMENT_TYPES.PHONE, label: 'Phone' },
  { value: BOOKING_APPOINTMENT_TYPES.VIDEO, label: 'Video' },
];

export const BOOKING_TYPES = {
  VISIT: 'visit',
  APPOINTMENT: 'appointment',
};

export const bookingTypes = [
  { value: BOOKING_TYPES.VISIT, label: 'Doctor visit' },
  { value: BOOKING_TYPES.APPOINTMENT, label: 'Phone & Video appointment' },
];

export const showBookingTypes = {
  [BOOKING_TYPES.VISIT]: "Doctor's visit",
  [BOOKING_TYPES.APPOINTMENT]: 'Phone & Video appointment'
};


export const VOUCHER_TYPES = {
  electronic: 'E_VOUCHER',
  paper: 'PAPER_VOUCHER',
};

export const errors = {
  none: '',
  timeoutETA: 'Sorry, ETA have changed. Please confirm booking again',
  timeoutPrice: 'Sorry, Price have changed. Please confirm booking again',
  provide: 'Sorry, all our doctors are busy at the moment. Please prebook a timeslot or try later.',
  notSupported: 'Sorry, we do not provide service in this postcode area',
};

export const initialAppointmentFormData = {
  clinicAppointmentId: '',
  postcode: '',
  address: {
    fullAddress: ''
  },
  email: '',
  phone:  {
    code: '+44',
    number: '',
  },
  price: '',
  redirectUrl: window.location.origin,
  patient: {
    title: '',
    forename: '',
    surname: '',
    dob: null,
  },
  clinicName: '',
  clinicId: '',
  serviceIds: [],
  slotName: '',
  slotId: '',
  symptoms: '',
  comments: '',
  forename: '',
  surname: '',
  acceptTerms: false,
  isAmendment: true,
  unpaid: false,
  clinicAppointmentServices: [],
  defaultBannerData: null,
};

export const appointmentErrors = {
  0: {
    errorMessage: "Bad Request : Can't submit payment: Card declined. Please try again or select another credit card"
    // "Bad Request : Can't submit payment: Invalid amount. Please try again or select another credit card"
  },
  1: {
    errorMessage: "Something went wrong. Please try again or make another appointment"
  },
  2: {
    errorMessage: "Appointment was already paid"
  },
  3: {
    errorMessage: "Appointment was cancelled due to payment timeout. Please create another appointment"
  },
}
